export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13337.b1af0dfa.jpg";